import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

export const CustomerService = (function () {
  let instance;
  const BASE_URI = '/apis/customers';
  const baseService = BaseService.getInstance(BASE_URI, 'customer');

  function init() {
    return {
      ...baseService,
      register: async function (data) {
        return await AxiosUtil.Async.post(BASE_URI, data);
      },
      update: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI, data);
      },
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI, queryString);
      },
      getData: async function (customerId) {
        return await AxiosUtil.Async.get(BASE_URI + `/${customerId}`);
      },
      delete: async function (customerId) {
        return await AxiosUtil.Async.delete(BASE_URI + `/${customerId}`);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
